(function($) {
	$map = $('#map, #map-contact');
    $map.each(function() {
        var mapId = $(this).attr('id');
    
        longitude = 7.4745721;
        latitude = 46.9390637;

        L.mapbox.accessToken = 'pk.eyJ1IjoiY3ViZXRlY2giLCJhIjoiNXNzUHdfbyJ9.tm-Kh0sz67FPbXgoKofkwQ';
        var map = L.mapbox.map(mapId, false, {
            zoomControl: false,
            center: [latitude, longitude],
            zoom: 15
        });

        L.mapbox.styleLayer('mapbox://styles/cubetech/cj7ipv1pp5lkf2sozup0fycv9').addTo(map);

        // Disable drag and zoom handlers.
        map.dragging.disable();
        map.touchZoom.disable();
        map.doubleClickZoom.disable();
        map.scrollWheelZoom.disable();

        if (map.tap) {
            map.tap.disable();
        }

        var myLayer = L.mapbox.featureLayer().addTo(map);
        var markers = [];

        markers.push({
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [longitude, latitude]
            },
        });

        myLayer.on('layeradd', function(e) {
            var marker = e.layer,
                feature = marker.feature;

            marker.setIcon(
                L.icon({
                    "iconUrl": anq.templateDir + "/assets/dist/images/map_icon-24.svg",
                    "iconSize": [40, 60],
                    "iconAnchor": [0, 60],
                    "className": "dot"
                })
            );
        });

        myLayer.setGeoJSON({
            type: 'FeatureCollection',
            features: markers
        });
    });
})(jQuery);